// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//


import {
    ChangeAllSelectFilterHandler,
    ChangeFilterHandler,
    ChangeFilterSearchHandler,
    FilterName,
    GetFilters,
    IsAllFiltersChecked,
    IsFilterChecked,
    ToggleFilter } from "@hardwoods/App/Widgets/PaidInvoices/PaidInvoices";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Checkbox from "@insite/mobius/Checkbox";
import Clickable from "@insite/mobius/Clickable";
import Icon from "@insite/mobius/Icon";
import X from "@insite/mobius/Icons/X";
import TextField from "@insite/mobius/TextField";
import React, { FC } from "react";

interface OwnProps {
    filterName: FilterName;
    filterSearch: { [key: string]: any };
    onChangeFilterSearch: ChangeFilterSearchHandler;
    onChangeAllSelectFilterHandler: ChangeAllSelectFilterHandler;
    onChangeFilterHandler: ChangeFilterHandler;
    isAllFiltersChecked: IsAllFiltersChecked;
    isFilterChecked: IsFilterChecked;
    getFilters: GetFilters;
    toggleFilter: ToggleFilter;
    style: any;
}

const PaidInvoiceFilter: FC<OwnProps> = ({
    filterName,
    filterSearch,
    onChangeFilterSearch,
    onChangeAllSelectFilterHandler,
    onChangeFilterHandler,
    isAllFiltersChecked,
    isFilterChecked,
    getFilters,
    toggleFilter,
    style,
}) => {
    return (
        <StyledWrapper {...style.filters.wrapper} className="invoice-filter">
            <StyledWrapper {...style.filters.searchWrapper}>
                <Clickable onClick={(event: React.MouseEvent) => toggleFilter(event, filterName)} {...style.filters.xIconWrapper}>
                    <Icon src={X} {...style.filters.xIcon} />
                </Clickable>
                <TextField
                    type="text"
                    placeholder={translate("Search")}
                    {...style.filters.searchField}
                    value={filterSearch[filterName]}
                    onChange={(event) => onChangeFilterSearch(event, filterName)}
                />
            </StyledWrapper>
            <StyledWrapper {...style.filters.checkboxGroup}>
                <Checkbox
                    key="select-all"
                    checked={isAllFiltersChecked(filterName)}
                    onChange={(event) => onChangeAllSelectFilterHandler(event, isAllFiltersChecked(filterName), filterName)}
                    {...style.filters?.checkbox}
                >
                    {translate("select all")}
                </Checkbox>
                {getFilters(filterName).map(filter => (
                    <Checkbox
                        key={filter}
                        onChange={(event) => onChangeFilterHandler(event, isFilterChecked(filterName, filter), filterName, filter)}
                        data-filter-name={filterName}
                        data-filter-value={filter}
                        checked={isFilterChecked(filterName, filter)} // Use the boolean value directly
                        {...style.filters?.checkbox}
                    >
                        {filter}
                    </Checkbox>
                ))}
            </StyledWrapper>
        </StyledWrapper>
    )
};

export default PaidInvoiceFilter;